import availableBarrierTypes from "@/utilities/barrierTypes";
import L from "leaflet";

class Barrier {
  constructor(id, index, name, position, active) {
    const currentBarrier = availableBarrierTypes[index];
    this.id = id;
    this.type = currentBarrier.type;
    this.name = name;
    this.position = position;
    this.active = active;
    this.icon = L.icon({
      iconUrl: currentBarrier.iconURL,
      iconSize: currentBarrier.iconSize
    });
    this.cost = currentBarrier.cost;
  }
}

export default Barrier;
